import { Rectangle } from "../../maths/Rectangle";
import { ClassUtils } from "../../utils/ClassUtils";
import { Pool } from "../../utils/Pool";
const className = "DrawCircleCmd";
export class DrawCircleCmd {
    constructor() {
        this.lineWidth = 0;
    }
    static create(x, y, radius, fillColor, lineColor, lineWidth, percent) {
        var cmd = Pool.getItemByClass(className, DrawCircleCmd);
        cmd.x = x;
        cmd.y = y;
        cmd.radius = radius;
        cmd.fillColor = fillColor;
        cmd.lineColor = lineColor;
        cmd.lineWidth = lineWidth;
        cmd.percent = percent;
        return cmd;
    }
    recover() {
        this.fillColor = null;
        this.lineColor = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        let offset = (this.lineWidth >= 1 && this.lineColor) ? this.lineWidth / 2 : 0;
        if (this.percent && runner.sprite) {
            let w = runner.sprite.width;
            let h = runner.sprite.height;
            runner._drawCircle(this.x * w + gx, this.y * h + gy, this.radius * Math.min(w, h) - offset, this.fillColor, this.lineColor, this.lineWidth, 0);
        }
        else
            runner._drawCircle(this.x + gx, this.y + gy, this.radius - offset, this.fillColor, this.lineColor, this.lineWidth, 0);
    }
    get cmdID() {
        return DrawCircleCmd.ID;
    }
    getBounds(assembler) {
        let rect = Rectangle.TEMP.setTo(this.x - this.radius, this.y - this.radius, this.radius + this.radius, this.radius + this.radius);
        if (this.percent) {
            rect.scale(assembler.width, assembler.height);
        }
        rect.getBoundPoints(assembler.points);
    }
}
DrawCircleCmd.ID = className;
ClassUtils.regClass(className, DrawCircleCmd);
